import { VYSION_ACTIONS } from '..';

const commonValues = {
  action: VYSION_ACTIONS.CLICK,
  page: 'Discover mode page',
  path: '/dashboard',
  extraInfo: '',
};

export const enum DiscoverModeClickVysionEventsEnum {
  DISCOVER_SWIPE_DISMISS = 'discover-swipe-dismiss',
  DISCOVER_TAP_DISMISS = 'discover-tap-dismiss',
  DISCOVER_SWIPE_OFFER = 'discover-swipe-offer',
  DISCOVER_TAP_OFFER = 'discover-tap-offer',
}

export const discoverModeClickVysionEvents = {
  [DiscoverModeClickVysionEventsEnum.DISCOVER_SWIPE_DISMISS]: {
    ...commonValues,
    eventName: DiscoverModeClickVysionEventsEnum.DISCOVER_SWIPE_DISMISS,
    component: 'Swipe Left',
  },
  [DiscoverModeClickVysionEventsEnum.DISCOVER_TAP_DISMISS]: {
    ...commonValues,
    eventName: DiscoverModeClickVysionEventsEnum.DISCOVER_TAP_DISMISS,
    component: 'Dismiss Button',
  },
  [DiscoverModeClickVysionEventsEnum.DISCOVER_SWIPE_OFFER]: {
    ...commonValues,
    eventName: DiscoverModeClickVysionEventsEnum.DISCOVER_SWIPE_OFFER,
    component: 'Swipe Right',
  },
  [DiscoverModeClickVysionEventsEnum.DISCOVER_TAP_OFFER]: {
    ...commonValues,
    eventName: DiscoverModeClickVysionEventsEnum.DISCOVER_TAP_OFFER,
    component: 'Offer Button',
  },
};
